import { FC, useState } from 'react';
import { IStudentClass } from '../../../../models/studentsClass.model';
import { TableColumnsType, Table } from 'antd';
import config from '../../../../lib/config';
import Pagination from '../../../Pagination';
import Button from '../../../Button';
import { IStudent } from '../../../../models/students.model';
import useAuth from '../../../../hooks/useAuth';
import moment from 'moment';
import { getCommonCodeLabel } from '../../../../lib/store';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface IProps {
  student?: IStudent;
  data?: IStudentClass[];

  onAssignmentClick(): void;
}

const ClassDefaultContents: FC<IProps> = ({
  student,
  data,
  onAssignmentClick,
}) => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const { writeAuthYn } = useAuth();
  const [page, setPage] = useState(1);

  const columns: TableColumnsType<IStudentClass> = [
    {
      title: t('student.student.column22'),
      dataIndex: 'semesterName',
      key: 'semesterName',
      align: "center",
      sorter: (a, b) => a.semesterName?.localeCompare(b.semesterName),
      render: (value) => {
        return (<div className='text-left ant-table-cell-ellipsis'>{value}</div>);
      }
    },
    {
      title: t('program.semester.column11'),
      dataIndex: 'semesterType',
      key: 'semesterType',
      align: "center",
      sorter: (a, b) => a.semesterType?.localeCompare(b.semesterType),
      render: (value) => {
        return (getCommonCodeLabel('PR0002', value, i18n.language));
      }
    },
    {
      title: t('student.student.column23'),
      dataIndex: 'className',
      key: 'className',
      align: "center",
      sorter: (a, b) => a.className?.localeCompare(b.className),
      render: (value) => {
        return (<div className='text-left ant-table-cell-ellipsis'>{value}</div>);
      }
    },
    {
      title: t('student.student.column24'),
      dataIndex: 'semesterSrtDate',
      key: 'semesterSrtDate',
      sorter: (a, b) => a.semesterSrtDate?.localeCompare(b.semesterSrtDate),
      render: value => moment(value).format('YYYY.MM.DD'),
    },
    {
      title: t('student.student.column25'),
      dataIndex: 'semesterEndDate',
      key: 'semesterEndDate',
      sorter: (a, b) => a.semesterEndDate?.localeCompare(b.semesterEndDate),
      render: value => moment(value).format('YYYY.MM.DD'),
    },
    {
      title: t('student.student.column26'),
      dataIndex: 'levelName',
      key: 'levelName',
      sorter: (a, b) => a.levelName?.localeCompare(b.levelName),
    },
    {
      title: t('student.student.column27'),
      dataIndex: 'courseName',
      key: 'courseName',
      sorter: (a, b) => a.courseName?.localeCompare(b.courseName),
    },
    {
      title: t('student.student.column4'),
      dataIndex: 'studyStatus',
      key: 'studyStatus',
      sorter: (a, b) => a.studyStatus?.localeCompare(b.studyStatus),
      render: value => getCommonCodeLabel('CL0003', value, i18n.language),
    },
  ];

  return (
    <>
      <div className="comm-bx__space">
        <div className="comm-btn__area right">
          <Button
            className="btn-basic pink-line"
            onClick={onAssignmentClick}
            text={t('student.student.button3')}
            writeAuthYn={writeAuthYn}
          />
        </div>
      </div>
      <Table
        className="comm-table__area"
        columns={columns}
        dataSource={data}
        pagination={{
          current: page,
          pageSize: config.pageSize,
        }}
        onRow={(record) => {
          return {
            onClick: () => {
              history.push(`/class/class2?classCode=${record.classCode}&campus=${student?.campusCode}&semester=${record.semesterCode}`);
            },
          };
        }}
        rowClassName="pointer"
        rowKey="classCode"          
      />
      <div className="comm-bx__between">
        <div className="common-paging center">
          <Pagination count={data?.length ?? 0} page={page} setPage={setPage} />
        </div>
      </div>
    </>
  );
};

export default ClassDefaultContents;
